import { useState } from "react";
import Panel from "../components/common/Panel";
import Seo from "../components/common/Seo";
import { t } from "../i18n/messages";
import { buildPath } from "../utils/routing";

export default function StudioPage({ locale }) {
  const [creator, setCreator] = useState(70);
  const [platform, setPlatform] = useState(20);
  const [partner, setPartner] = useState(10);
  const total = creator + platform + partner;

  return (
    <>
      <Seo
        locale={locale}
        title={`Chronos Arte Node | ${t(locale, "navStudio")}`}
        description={t(locale, "studioDesc")}
        path={buildPath(locale, "studio")}
      />

      <Panel title={t(locale, "navStudio")} description={t(locale, "studioPanelDesc")}>
        <div className="card-grid two-cols">
          <article className="card-link">
            <h3>{t(locale, "studioBatchListingTitle")}</h3>
            <p>{t(locale, "studioBatchListingDesc")}</p>
          </article>
          <article className="card-link">
            <h3>{t(locale, "studioActivityTitle")}</h3>
            <p>{t(locale, "studioActivityDesc")}</p>
          </article>
        </div>
      </Panel>

      <Panel title={t(locale, "studioRevenueTitle")} description={t(locale, "studioRevenueDesc")}>
        <div className="form-grid three-cols">
          <label>
            {t(locale, "studioCreatorPercent")}
            <input type="number" value={creator} onChange={(e) => setCreator(Number(e.target.value || 0))} />
          </label>
          <label>
            {t(locale, "studioPlatformPercent")}
            <input type="number" value={platform} onChange={(e) => setPlatform(Number(e.target.value || 0))} />
          </label>
          <label>
            {t(locale, "studioPartnerPercent")}
            <input type="number" value={partner} onChange={(e) => setPartner(Number(e.target.value || 0))} />
          </label>
        </div>
        <div className={`status-banner ${total === 100 ? "success" : "error"}`}>
          <strong>{total === 100 ? t(locale, "studioValid") : t(locale, "studioInvalid")}</strong>
          <p>{t(locale, "studioCurrentTotal")}: {total}%</p>
        </div>
      </Panel>
    </>
  );
}
